<template>
    <div id="customCheckbox_main" @click="toggle">
        <i v-if="checked" class="fas fc-main" :class="icon"></i>
        <i v-else class="far fa-square fc-black"></i>
    </div>
</template>

<script>
  export default {
    name: 'customCheckbox',
    props: {
      icon: {
        type: String,
        default: 'fa-check-square'
      }
    },
    data(){
      return{
        checked: false,
      }
    },
    methods: {
      toggle(){
        this.checked = !this.checked;
        this.$emit('input', this.checked);
      }
    }
  }
</script>

<style scoped>

</style>
